// extracted by mini-css-extract-plugin
export default {"root":"LockAvailabilityForm_root__aHIwe"};